module.exports = __webpack_public_path__ + "static/media/II-icon.b4d11ca4.svg";